import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { DisciplinaActions } from 'Store/Disciplina/Disciplina.actions';
import { IDisciplineRequest } from 'Data/interfaces/Obra/IDisciplineRequest';
import Modal from 'Components/UI/Modal';
import Button from 'Components/UI/Button';
import Field from 'Components/UI/Field';
import Form from 'Components/UI/Form/Form';
import { createSchema } from './cadastroDisciplina.schema';
import { ButtonsWrapper, DisciplinaWrapper } from './styles';

interface ICadastroDisciplina {
  visible?: boolean;
  id?: number;
  description?: string;
  constructionSiteId: number;
  loading?: boolean;
  onCancel: () => void;
}

const CadastroDisciplina: FC<ICadastroDisciplina> = ({
  visible,
  id,
  description,
  constructionSiteId,
  loading,
  onCancel,
}) => {
  const { t } = useTranslation('disciplinas');
  const dispatch = useDispatch();

  const schema = useMemo(() => createSchema(t), [t]);
  const [isSubmit, setIsSubmit] = useState(false);

  const submit = (values: any) => {
    const discipline: IDisciplineRequest = {
      ConstructionSiteId: constructionSiteId,
      Name: values.description,
    };
    if (id) {
      discipline.Id = id;
    }
    dispatch(DisciplinaActions.createOrUpdate(discipline));
    setIsSubmit(false);
  };

  const buttons = (
    <ButtonsWrapper>
      <Button
        onClick={onCancel}
        type="text"
        className="buttonCancel"
      >
        {t('cadastroDisciplina.cancel')}
      </Button>
      <Button
        type="primary"
        htmlType="submit"
        onClick={() => setIsSubmit(true)}
        className="buttonSubmit"
        disabled={loading}
        loading={loading}
      >
        {t('cadastroDisciplina.confirm')}
      </Button>
    </ButtonsWrapper>
  );

  return (
    <Modal
      visible={visible}
      title={id ? t('cadastroDisciplina.titleEdit') : t('cadastroDisciplina.titleCreate')}
      footerButtons={buttons}
      footerActive={false}
      width={600}
      customClassName
      newHeader
      onCancel={onCancel}
    >
      <DisciplinaWrapper>
        <Form
          schema={schema}
          isSubmited={isSubmit}
          className='disciplinaForm'
          onSubmit={submit}
        >
          <Field
            label={t('cadastroDisciplina.fieldLabel')}
            name='description'
            className='inputDescription'
            defaultValue={description}
            disabled={loading}
          />
        </Form>
      </DisciplinaWrapper>
    </Modal>
  );
};

export default CadastroDisciplina;
